import { catalogResponseSchema } from "@chotca/config";
import type { RequestContext } from "./http";
import { requestJson } from "./http";

export function createCatalogsResource(ctx: RequestContext) {
  return {
    /** Cache 1d ở FE — vocabulary nhất quán cho web/mobile/BE. */
    get() {
      return requestJson(ctx, {
        method: "GET",
        path: `/catalogs`,
        dataSchema: catalogResponseSchema,
        auth: false,
      });
    },
  };
}
